import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { ButtonsComponent } from './buttons.component';
import { DashboardComponent } from './dashboard.component';



@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    DashboardRoutingModule
  ],
  declarations: [
    DashboardComponent,ButtonsComponent
  ],
  providers: [
  ]
})

export class DashboardModule {
}
